import { Component } from "@angular/core";

@Component({
  selector: "oz-stepper-page",
  template: "<ng-content></ng-content>",
})
export class PageComponent {}
